/* eslint-disable func-style */
// 代收费路由
const ChargeList = () => import('@/pages/Dsf/ChargeList.vue');
const RefundPrintRecord = () => import('@/pages/Dsf/RefundPrintRecord.vue');
const RefundRecord = () => import('@/pages/Dsf/RefundRecord.vue');
const supplementaryFee = () => import('@/pages/Dsf/supplementaryFee');
const totalSurrogateFees = () => import('@/pages/Dsf/totalSurrogateFees');
const AgencyFeeDetails = () => import('@/pages/Dsf/agencyFeeDetails');
const RightPanel = () => import('@/components/RightPanel');
const RefundPrintRecordDetails = () => import('@/pages/Dsf/RefundPrintRecordDetails.vue');

const generationChargeRouter = [
	{
		path: '/ChargeList',
		name: 'ChargeList',
		component: ChargeList,
	},
	{
		path: '/RefundPrintRecord',
		name: 'RefundPrintRecord',
		component: RefundPrintRecord,
		children: [
			{
				path: '/RefundPrintRecordRightPanel',
				name: 'RefundPrintRecordRightPanel',
				component: RightPanel,
				meta: { parent: 'RefundPrintRecord' },
				children: [
					{
						path: '/RefundPrintRecordDetails/:details',
						name: 'RefundPrintRecordDetails',
						component: RefundPrintRecordDetails,
						meta: { parent: '/RefundPrintRecord' },
					},
				],
			},
		],
		meta: { title: '退款打印记录' },
	},
	{
		path: '/RefundRecord',
		name: 'RefundRecord',
		component: RefundRecord,
	},
	{
		path: '/SupplementaryFee',
		name: '/SupplementaryFee',
		component: supplementaryFee,
		meta: {
			title: '费用补交清单',
		},
	},
	{
		path: '/TotalSurrogateFees',
		name: '/TotalSurrogateFees',
		component: totalSurrogateFees,
		meta: {
			title: '代收费用合计',
		},
	},
	{
		path: '/AgencyFeeDetails',
		name: 'AgencyFeeDetails',
		component: AgencyFeeDetails,
		children: [
			{
				path: '/AgencyFeeDetailRightPanel',
				name: 'AgencyFeeDetailRightPanel',
				component: RightPanel,
				children: [
					{
						path: '/FeeDetails/:id',
						name: 'FeeDetails',
						component: () => import('@/pages/Dsf/agencyFeeDetails/component/FeeDetails'),
						meta: { parent: '/AgencyFeeDetails' },
					},
				],
			},
		],
		meta: { title: '代收费用明细' },
	},
	{
		path: '/AgencyFeeDetailEdit/:id/:data',
		name: 'AgencyFeeDetailEdit',
		component: () => import('@/pages/Dsf/agencyFeeDetails/component/AgencyFeeDetailEdit'),
	},
]

export default generationChargeRouter
